import * as React from "react";

function SvgErraticDemand(props) {
  return <svg width={16} height={16} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M1 12l3-8 3 8h3l3-4 2 3.467" stroke="#FF825C" /></svg>;
}

export default SvgErraticDemand;